import 'babel-polyfill';
/**
 * Extend Error class for API errors in order to be able to catch them specifically
 * @param {String} message The message of the error
 * @constructor
 */
export default class ApiError extends Error {
    constructor(message, response, responseBackend) {
        super(message);

        this.message = message || 'Generic API error';
        this.response = response;
        if (responseBackend) {
            this.responseBackend = {detail: [responseBackend]};
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/api/errors/ApiError.js